// extracted by mini-css-extract-plugin
export default {"priceContainer":"yca-z","discountedPrice":"zca-z","originalPrice":"Aca-z","productPrice":"Bca-z"};